import { Box, List, ListItem, IconButton, Stack } from '@mui/material';

import { useEffect, useState } from 'react';

import { ReactComponent as DrawerClose } from 'common/assets/images/drawer-close.svg';
import ButtonComp from 'common/components/Button/ButtonComp';
import { scrollProps } from 'common/utils/utilFunctions';

import {
	ICitationDetailsElements,
	ICitationGroup,
	ISelectedCitationGroups,
} from '../api/type-def';

import styles from './CitationGroupList.module.scss';

interface ICitationGroupList {
	node: ICitationDetailsElements;
	groupList: ISelectedCitationGroups[];
	handleClose: () => void;
	deleteGroup: (group: ICitationGroup, parentId: string) => void;
	allowEdit: boolean;
}

const CitationGroupList = (props: ICitationGroupList) => {
	const { node, groupList, allowEdit, handleClose, deleteGroup } = props;
	const [selectedIndex, setSelectedIndex] = useState<number>();
	const [deleteGroupNode, setDeleteGroupNode] = useState<ICitationGroup>();

	// Store only unique group Names
	const [displayGroupsList, setDisplayGrousList] = useState<ICitationGroup[]>(
		[],
	);
	const { drawerCloseIconColor, scrollbarTrack } = styles;

	useEffect(() => {
		if (groupList.length && node.id) {
			const regulationGroups = groupList.reduce((acc, elem) => {
				if (elem?.parentId === node.id) {
					acc.push(...elem.group);
				}
				return acc;
			}, [] as ICitationGroup[]);
			const uniqArray = regulationGroups.filter(
				(item, index, self) =>
					index ===
					self.findIndex(
						(temp: ICitationGroup) => temp.groupId === item.groupId,
					),
			);
			setDisplayGrousList(uniqArray);
		}
		setDeleteGroupNode(undefined);
	}, [node]);

	const setListHover = (index: number) => {
		setSelectedIndex(index);
	};

	const onHideListActions = () => {
		setSelectedIndex(-1);
	};

	const cancleHandleClick = () => {
		setDeleteGroupNode(undefined);
	};
	const deleteHandleClick = () => {
		if (deleteGroupNode) {
			const group = deleteGroupNode;
			deleteGroup(group, node.id);
			const filtered = displayGroupsList.filter(
				(el) => el.groupId !== group.groupId,
			);
			setDisplayGrousList(() => [...filtered]);
			setDeleteGroupNode(undefined);
		}
	};

	const handleGroupDelete = (element: ICitationGroup) => {
		setDeleteGroupNode(element);
	};

	return (
		<List className={styles['list-wrapper']}>
			<ListItem className={styles['list-wrapper-header']}>
				<Box>Associated Groups</Box>
				<IconButton
					size="small"
					onClick={handleClose}
					data-testid="close-groups-btn-head"
					className={styles['list-wrapper-button']}
				>
					<DrawerClose fill={drawerCloseIconColor} />
				</IconButton>
			</ListItem>
			<hr />
			<Box
				className={styles['list-wrapper-scroll']}
				sx={scrollProps('y-axis', scrollbarTrack)}
			>
				{displayGroupsList.length === 0 && (
					<Box className={styles['list-wrapper-items-flex']}>
						{' '}
						No Groups found
					</Box>
				)}
				{displayGroupsList.map((element: ICitationGroup, index: number) => {
					const displayDeleteIcon = selectedIndex === index && allowEdit;
					const displayButton =
						displayDeleteIcon && element.groupId === deleteGroupNode?.groupId;
					return (
						<ListItem
							key={`group-list-item-${element.groupId}`}
							data-testId={element.groupId}
							className={styles['list-wrapper-li']}
							onMouseOver={() => {
								setListHover(index);
							}}
							onFocus={() => {
								setListHover(index);
							}}
							onMouseOut={onHideListActions}
							onBlur={onHideListActions}
						>
							<>
								{!displayButton && (
									<Box className={styles['list-wrapper-items-flex']}>
										<Box className={styles['list-wrapper-items']}>
											{element.groupName}
										</Box>
										{displayDeleteIcon && (
											<IconButton
												size="small"
												onClick={() => {
													handleGroupDelete(element);
												}}
												data-testid="close-groups-btn"
												className={styles['list-wrapper-button']}
											>
												<DrawerClose fill={drawerCloseIconColor} />
											</IconButton>
										)}
									</Box>
								)}
								{displayButton && (
									<Stack
										direction="row"
										justifyContent="space-evenly"
										className={styles['list-wrapper-items-flex-button']}
									>
										<ButtonComp
											clickHandler={cancleHandleClick}
											btnType="secondary"
											data-testid="cancel-btn"
											compClass={styles['btn-cancel']}
										>
											Cancel
										</ButtonComp>
										<ButtonComp
											btnType="primary"
											clickHandler={deleteHandleClick}
											data-testid="delete-btn"
											compClass={styles['btn-delete']}
										>
											Delete
										</ButtonComp>
									</Stack>
								)}
							</>
						</ListItem>
					);
				})}
			</Box>
		</List>
	);
};

export default CitationGroupList;
